import { render, staticRenderFns } from "./EditSelection.vue?vue&type=template&id=2027a339&scoped=true"
import script from "./EditSelection.vue?vue&type=script&lang=js"
export * from "./EditSelection.vue?vue&type=script&lang=js"
import style0 from "./EditSelection.vue?vue&type=style&index=0&id=2027a339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2027a339",
  null
  
)

export default component.exports